import { categoryModal } from "models/complaints/complaint-modals";
import { User } from "models/user-models";

export interface WizardOptionModal {
  id: string
  page_name: string
}

export interface UpdatedReportModal {
  system: categoryModal | null
  complaints: categoryModal[]
  otherSymptoms: categoryModal[]
  history: categoryModal[]
  examinations: ExaminationModal[]
  impressions: categoryModal[]
  treatment_plans: categoryModal[]
}

export interface LocationWithScrollDowns {
  description: string;
  scrollDowns: string[];
}

export interface reportModal {
  user?: User;
  system: categoryModal;
  duration?: number | null;
  durationType?: string;
  complaints?: categoryModal[];
  subComplaints?: categoryModal[];
  complaintLocation?: LocationWithScrollDowns[];
  examinationLocation?: LocationWithScrollDowns[];
  otherSymptomRemark?: string;
  otherSymptomLocation?: LocationWithScrollDowns[];
  historyRemark?: string;
  subComplaintRemark?: string;
  complaintRemark?: string;
  impressionRemark?: string
  examinationRemark?: string
  treatmentRemark?: string;
  examinations?: ExaminationModal[];
  impressions?: categoryModal[];
  treatment_plans?: categoryModal[];
  otherSymptoms?: categoryModal[];
  history?: categoryModal[];
  reportName?: string;
  createdOn?: Date;
  createdBy?: string;
  otherSymptomDuration?: number | null
  otherSymptomDurationType?: string
  historyDuration?: number | null
  historyDurationType?: string
  impressionLocation?: LocationWithScrollDowns[];
  assessmentLocation?: LocationWithScrollDowns[];
}

export interface wizardDisplayModal {
  id: string;
  description?: string;
  system_id?: string[];
  priority?: number | { base: number; [key: string]: number };
}
export interface defaultBtn {
  id: string;
  description?: string;
}
export interface dialogOpenModal {
  title: string
}

export interface defaultBtnObj {
  inputValue: string
  unitValue: string
}

export interface WizardProps {
  selectedUser?: User;
  userReport?: UpdatedReportModal;
  page?: number;
  setPage?: React.Dispatch<React.SetStateAction<number>>;
  setReport?: React.Dispatch<React.SetStateAction<UpdatedReportModal>>;
  systemList?: categoryModal[]
  complaintList?: categoryModal[]
  otherSymptomList?: categoryModal[]
  historyList?: categoryModal[]
  durationList?: wizardDisplayModal[]
  examinationList?: ExaminationModal[]
  impressionList?: EITModal[]
  treatmentList?: EITModal[]
  handleSelectedUser?: (User: User) => void;
  updateReportList?: (data: WizardOptionModal[], selectedSubOtherSymptom: wizardDisplayModal[], selectedSubHistory: wizardDisplayModal[], selectedSubExams: wizardDisplayModal[], selectedSubImp: wizardDisplayModal[], selectedSubComp: wizardDisplayModal[], selectedSubTreatPlan: wizardDisplayModal[]) => void;
  duration?: number | null
  setDuration?: (duration: number | null) => void
  durationType?: string
  setDurationType?: (durationType: string) => void
  setIsCompleted?: (isCompleted: boolean) => void
  complaintRemark?: string
  subComplaintRemark?: string
  impressionRemark?: string
  examinationRemark?: string
  treatmentRemark?: string
  setTreatmentRemark?: (remarks: string) => void
  setComplaintRemark?: (remarks: string) => void
  setSubComplaintRemark?: (remarks: string) => void
  setImpressionRemark?: (remarks: string) => void
  setExaminationRemark?: (remarks: string) => void
  data?: { description: string; value: defaultBtnObj[] }[];
  setData?: React.Dispatch<React.SetStateAction<{ description: string; value: defaultBtnObj[] }[]>>;
  otherSymptomRemark?: string
  setOtherSymptomRemark?: (remarks: string) => void
  otherSymptomDuration?: number | null
  setOtherSymptomDuration?: (duration: number | null) => void
  otherSymptomDurationType?: string
  setOtherSymptomDurationType?: (durationType: string) => void
  historyRemark?: string
  setHistoryRemark?: (remarks: string) => void
  historyDuration?: number | null
  setHistoryDuration?: (duration: number | null) => void
  historyDurationType?: string
  setHistoryDurationType?: (durationType: string) => void
  resetSelectedOptions?: () => void;
  resetTrigger?: boolean;
  setResetTrigger?: (value: boolean) => void;
  complaintLocation?: LocationWithScrollDowns[];
  setComplaintLocation?: React.Dispatch<React.SetStateAction<LocationWithScrollDowns[]>>;
  examinationLocation?: LocationWithScrollDowns[];
  setExaminationLocation?: React.Dispatch<React.SetStateAction<LocationWithScrollDowns[]>>;
  otherSymptomLocation?: LocationWithScrollDowns[];
  setOtherSymptomLocation?: React.Dispatch<React.SetStateAction<LocationWithScrollDowns[]>>;
  impressionLocation?: LocationWithScrollDowns[];
  setImpressionLocation?: React.Dispatch<React.SetStateAction<LocationWithScrollDowns[]>>;
  locationList?: LocationModal[]
  onVoiceReportGenerated?: (report: UpdatedReportModal & Record<string, any>) => void;
  onVoiceModeChange?: (enabled: boolean) => void;

}

export interface wizardSelectionModal {
  pageID: number;
  pageName?: string;
  pageList: wizardPageListModal[];
}

export interface wizardPageListModal {
  id: string;
  description: string;
  isSelected: boolean;
}

export interface wizardIterationModal {
  iterationName: string;
  iterationState: boolean;
}

//Examination, Impression and Treatment modal
export interface EITModal {
  _id: string;
  parent_ids?: string[];
  parent_name?: string;
  description: string;
  priority?: number | { base: number; [key: string]: number };
  scroll_downs?: string[];
  system_id: string[];
  added_by?: string;
  added_on?: string;
}

export interface DefaultBtnModelProps {
  desc: string;
  data: Array<{ description: string; value: defaultBtnObj[] }>;
  isSelected: boolean;
  onSubmit: (desc: string, value: defaultBtnObj[]) => void;
  isInData: boolean;
  onRemove: (desc: string) => void;
  textSize?: "small" | "medium" | "large";
}

export interface ScrollDown {
  description: string
  priority: number
}

export interface ExaminationModal {
  _id: string;
  description: string;
  value?: { inputValue: string; unitValue: string };
  priority?: number | { base: number; [key: string]: number };
  scroll_downs: ScrollDown[]
  added_by?: string;
  added_on?: string;
}

export interface wizardHeadingModal {
  optionNumber?: number,
  heading?: string;
  subHeading?: string;
  isActive?: boolean;
}

export interface LocationModal {
  description: string;
  priority: number;
  system_id?: string[];
  scroll_downs?: ScrollDown[];
  _id?: string;
  muscle_id?: string;
  gender?: "male" | "female";
  side?: "front" | "back";
}

export const wizardHeadingArray: wizardHeadingModal[] = [
  {
    optionNumber: 1,
    heading: "COMPLAINTS",
    subHeading: "What symptoms is the patient experiencing?",
    isActive: true
  },
  {
    optionNumber: 2,
    heading: "DURATION",
    subHeading: "When did the symptoms first appear?",
    isActive: false
  },
  {
    optionNumber: 3,
    heading: "EXAMINATION",
    subHeading: "What examinations or tests do you recommend for the patient?",
    isActive: false
  },
  {
    optionNumber: 4,
    heading: "ASSESSMENT",
    subHeading: "What is your assessment for the patient?",
    isActive: false
  },
  {
    optionNumber: 5,
    heading: "PLAN",
    subHeading: "What plan do you recommend for the patient?",
    isActive: false
  },
]

export const wizardIterationArray: wizardIterationModal[] = [
  { iterationName: "Complaints", iterationState: true },
  { iterationName: "Duration", iterationState: false },
  { iterationName: "Examination", iterationState: false },
  { iterationName: "Assessment", iterationState: false },
  { iterationName: "Plans", iterationState: false }
]

export const durationListArray: wizardDisplayModal[] = [
  { id: "1day", description: "1 Day Ago", system_id: [] },
  { id: "3days", description: "3 Days Ago", system_id: [] },
  { id: "5days", description: "5 Days Ago", system_id: [] },
  { id: "1week", description: "1 Week Ago", system_id: [] },
  { id: "weekPlus", description: "More then 1 Week", system_id: [] },
]

const getScrollDownsText = (scrollDowns: any) => {
  if (!scrollDowns || scrollDowns.length === 0) return "";
  return scrollDowns.map((sd: any) => sd.description || sd).join(", ");
};

export const formatLocationItem = (l: any): string => {
  if (!l) return "";
  if (typeof l === "string") return l;
  const sds = l.scrollDowns || l.scroll_downs;
  if (Array.isArray(sds) && sds.length > 0) {
    const validSds = sds
      .map((sd: any) => (typeof sd === "string" ? sd : sd?.description || ""))
      .filter((s: string) => s && s.trim().length > 0);
    if (validSds.length > 0) {
      return validSds.join(", ");
    }
  }
  return l.description || l.name || "";
};

export const formatLocationsText = (locations: any[]): string => {
  if (!Array.isArray(locations) || locations.length === 0) return "";
  return locations
    .map((l) => formatLocationItem(l))
    .filter((text) => text && text.trim().length > 0)
    .join(", ");
};


export const formatReportData = (data: reportModal) => {
  let formattedData = "";

  // Chief Complaints (S:)
  if (data.complaints && data.complaints.length > 0) {
    formattedData += "S:\n";
    data.complaints.forEach((complaint) => {
      formattedData += complaint.description;

      if (complaint.scroll_downs && complaint.scroll_downs.length > 0) {
        formattedData += " ";
        complaint.scroll_downs.forEach((sd: any, index: any) => {
          formattedData += sd;
          formattedData += index < complaint.scroll_downs.length - 1 ? ", " : " ";
        });
        formattedData += " ";
      }

      if (data.duration !== null || (data.durationType && data.durationType !== "Seconds" && data.durationType !== "")) {
        if (data.duration !== undefined && data.duration !== null && !isNaN(data.duration)) {
          const durationText =
            data.duration != 1
              ? data.durationType?.slice(-1) === "s"
                ? data.durationType
                : data.durationType + "s"
              : data.durationType?.slice(-1) === "s"
                ? data.durationType.slice(0, -1)
                : data.durationType;
          formattedData = formattedData.trimEnd();
          formattedData += ` since ${data.duration} ${durationText}\n`;
        } else if (data.durationType && data.durationType !== "Seconds" && data.durationType !== "") {
          formattedData = formattedData.trimEnd();
          formattedData += ` since ${data.durationType.toLowerCase()}\n`;
        } else {
          formattedData += "\n";
        }
      } else {
        formattedData += "\n";
      }
    });

    const complaintLocText = formatLocationsText(data.complaintLocation);
    if (complaintLocText) {
      formattedData += `Location: ${complaintLocText}\n`;
    }

    if (data.complaintRemark) {
      formattedData += `${data.complaintRemark}\n`;
    }

    formattedData += "\n";
  }

  // Other Symptoms (no header — matches UI)
  if (data.otherSymptoms && data.otherSymptoms.length > 0) {
    data.otherSymptoms.forEach((os: any, index: number) => {
      if (index !== 0) formattedData += "\n";
      formattedData += os.description + " ";

      if (os.scroll_downs && os.scroll_downs.length > 0) {
        os.scroll_downs.forEach((sd: any, i: number) => {
          formattedData += sd;
          formattedData += i < os.scroll_downs.length - 1 ? ", " : " ";
        });
      }
    });

    if (data.otherSymptomDuration !== null || (data.otherSymptomDurationType && data.otherSymptomDurationType !== "Seconds" && data.otherSymptomDurationType !== "")) {
      if (data.otherSymptomDuration !== undefined && data.otherSymptomDuration !== null && !isNaN(data.otherSymptomDuration)) {
        const durationText =
          data.otherSymptomDuration != 1
            ? data.otherSymptomDurationType?.slice(-1) === "s"
              ? data.otherSymptomDurationType + " "
              : data.otherSymptomDurationType + "s "
            : data.otherSymptomDurationType?.slice(-1) === "s"
              ? data.otherSymptomDurationType.slice(0, -1)
              : data.otherSymptomDurationType;
        formattedData += `\nFor ${data.otherSymptomDuration} ${durationText}`;
      } else if (data.otherSymptomDurationType && data.otherSymptomDurationType !== "Seconds" && data.otherSymptomDurationType !== "") {
        formattedData += `\nFor ${data.otherSymptomDurationType.toLowerCase()}`;
      }
    }

    const otherSymptomLocText = formatLocationsText(data.otherSymptomLocation);
    if (otherSymptomLocText) {
      formattedData += `\nLocation: ${otherSymptomLocText}`;
    }

    if (data.otherSymptomRemark) {
      formattedData += `\n${data.otherSymptomRemark}`;
    }

    formattedData += "\n";
  } else if (data.otherSymptomRemark) {
    // UI shows otherSymptomRemark even when otherSymptoms is empty, without a leading <br>
    formattedData += `${data.otherSymptomRemark}\n`;
  }

  // History (H:)
  if ((data.history && data.history.length > 0) || data.historyRemark) {
    formattedData += "\nH:\n";

    if (data.history && data.history.length > 0) {
      data.history.forEach((os: any) => {
        formattedData += os.description + " ";

        if (os.scroll_downs && os.scroll_downs.length > 0) {
          os.scroll_downs.forEach((sd: any, i: number) => {
            formattedData += sd;
            formattedData += i < os.scroll_downs.length - 1 ? ", " : "";
          });
        }

        formattedData += "\n";
      });

      if (data.historyDuration !== null || (data.historyDurationType && data.historyDurationType !== "Seconds" && data.historyDurationType !== "")) {
        if (data.historyDuration !== undefined && data.historyDuration !== null && !isNaN(data.historyDuration)) {
          const durationText =
            data.historyDuration != 1
              ? data.historyDurationType?.slice(-1) === "s"
                ? data.historyDurationType
                : data.historyDurationType + "s"
              : data.historyDurationType?.slice(-1) === "s"
                ? data.historyDurationType.slice(0, -1)
                : data.historyDurationType;
          formattedData += `For ${data.historyDuration} ${durationText}\n`;
        } else if (data.historyDurationType && data.historyDurationType !== "Seconds" && data.historyDurationType !== "") {
          formattedData += `For ${data.historyDurationType.toLowerCase()}\n`;
        }
      }
    }

    if (data.historyRemark) {
      formattedData += `${data.historyRemark}`;
    }

    formattedData += "\n";
  }

  // Examinations (O/E:)
  const mergedExaminations =
    data.examinations && data.examinations.length > 0 ? data.examinations : [];

  if (mergedExaminations.length > 0 || data.examinationRemark) {
    formattedData += "\nO/E:\n";

    // Separate vitals and other examinations to show vitals first
    const vitals = mergedExaminations.filter((item: any) =>
      item.description === "Temperature" ||
      item.description === "Blood Pressure" ||
      item.description === "Heart Rate" ||
      item.description === "Height & Weight" ||
      item.description === "Body Mass Index"
    );
    const otherExams = mergedExaminations.filter((item: any) =>
      !(item.description === "Temperature" ||
        item.description === "Blood Pressure" ||
        item.description === "Heart Rate" ||
        item.description === "Height & Weight" ||
        item.description === "Body Mass Index")
    );

    [...vitals, ...otherExams].forEach((item: any) => {
      const isStaticExamination =
        item.description === "Temperature" ||
        item.description === "Blood Pressure" ||
        item.description === "Heart Rate" ||
        item.description === "Height & Weight" ||
        item.description === "Body Mass Index";

      let weightKG, weightPounds, heightFeets, heightInches, heightCM, tempUnit;

      if (item.description === "Height & Weight") {
        weightKG = item.value?.find((x: any) => x.unitValue === "Kilos");
        weightPounds = item.value?.find((x: any) => x.unitValue === "Pounds");
        heightCM = item.value?.find((x: any) => x.unitValue === "Centimeters");
        heightFeets = item.value?.find((x: any) => x.unitValue === "Feets");
        heightInches = item.value?.find((x: any) => x.unitValue === "Inches");
      }

      if (item.description === "Temperature" && item.value?.[0]?.unitValue) {
        tempUnit = item.value[0].unitValue === "Fahrenheit" ? "F°" : "C°";
      }

      let line = "";

      if (weightKG) {
        line = `Height: ${heightCM?.inputValue} centimeters, Weight: ${weightKG?.inputValue} kilos`;
      } else if (weightPounds) {
        line = `Height: ${heightFeets?.inputValue} feets ${heightInches?.inputValue} inches, Weight: ${weightPounds?.inputValue} pounds`;
      } else {
        line += item.description;
        line += isStaticExamination ? ": " : " ";
        line += item.value?.[0]?.inputValue ?? "";
        if (item.description === "Temperature") {
          line += tempUnit ?? "";
        } else if (item.value?.[0]?.unitValue) {
          line += ` ${item.value[0].unitValue}`;
        }
      }

      // Scroll downs on the same line
      if (item.scroll_downs && item.scroll_downs.length > 0) {
        line += " " + item.scroll_downs.map((sd: any) => sd.description ?? sd).join(", ");
      }

      formattedData += line + "\n";
    });

    const examLocText = formatLocationsText(data.examinationLocation);
    if (examLocText) {
      formattedData += `Location: ${examLocText}\n`;
    }

    if (data.examinationRemark) {
      formattedData += `${data.examinationRemark}\n`;
    }

    formattedData += "\n";
  }

  // Impressions (A:)
  const impLocations = data.impressionLocation || data.assessmentLocation;
  if ((data.impressions && data.impressions.length > 0) || data.impressionRemark || (Array.isArray(impLocations) && impLocations.length > 0)) {
    formattedData += "\nA:\n";

    if (data.impressions && data.impressions.length > 0) {
      data.impressions.forEach((impression: any) => {
        formattedData += impression.description + " ";

        if (impression.scroll_downs && impression.scroll_downs.length > 0) {
          impression.scroll_downs.forEach((sd: any, i: number) => {
            formattedData += sd;
            formattedData += i < impression.scroll_downs.length - 1 ? ", " : "";
          });
        }

        formattedData += "\n";
      });
    }

    const impLocText = formatLocationsText(impLocations);
    if (impLocText) {
      formattedData += `Location: ${impLocText}\n`;
    }

    if (data.impressionRemark) {
      formattedData += `${data.impressionRemark}`;
    }

    formattedData += "\n";
  }

  // Treatment Plans (P:)
  if ((data.treatment_plans && data.treatment_plans.length > 0) || data.treatmentRemark) {
    formattedData += "\nP:\n";

    if (data.treatment_plans && data.treatment_plans.length > 0) {
      data.treatment_plans.forEach((treatment: any) => {
        formattedData += treatment.description + " ";

        if (treatment.scroll_downs && treatment.scroll_downs.length > 0) {
          formattedData += "\n";
          treatment.scroll_downs.forEach((sd: any, i: number) => {
            formattedData += `- ${sd}`;
            formattedData += i < treatment.scroll_downs.length - 1 ? "\n" : "";
          });
        }

        formattedData += "\n";
      });
    }

    if (data.treatmentRemark) {
      formattedData += `${data.treatmentRemark}`;
    }
  }

  return formattedData;
};